var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcussion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0187 29.3334C26.0688 29.3334 29.3521 26.0501 29.3521 22C29.3521 17.9499 26.0688 14.6667 22.0187 14.6667C17.9686 14.6667 14.6854 17.9499 14.6854 22C14.6854 26.0501 17.9686 29.3334 22.0187 29.3334Z",
    fill: "#F1786C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68539 3.66669L7.35206 7.33335M40.3521 3.66669L36.6854 7.33335M40.3521 40.3334L36.6854 36.6667M3.68539 40.3334L7.35206 36.6667M3.68539 29.3334H6.43539M14.6854 3.66669V6.41669M40.3521 14.6667H37.6021M29.3521 40.3334V37.5834M33.0187 29.3334H39.4354M29.3521 3.66669V11M3.68539 14.6667H11.0187M14.6854 40.3334V33M29.3521 22C29.3521 26.0501 26.0688 29.3334 22.0187 29.3334C17.9686 29.3334 14.6854 26.0501 14.6854 22C14.6854 17.9499 17.9686 14.6667 22.0187 14.6667C26.0688 14.6667 29.3521 17.9499 29.3521 22Z",
    stroke: "#3F2C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcussion);
export default __webpack_public_path__ + "static/media/concussion.9142280061434134426591e99c662300.svg";
export { ForwardRef as ReactComponent };